import React, { FC, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useCanvaService } from '../services/canvaService';

export const ConnectToCanva: FC = () => {
  const [searchParams] = useSearchParams();

  const { loading, connectToCanva: connect } = useCanvaService();

  useEffect(() => {
    const fetch = async () => {
      const connectToCanva = async (code: string, state: string) => {
        await connect(code, state);
      };
      try {
        await connectToCanva(searchParams.get('code') || '', searchParams.get('state') || '');
        window.close();
      } catch (e) {
        console.log(e);
        window.close();
      }
    };
    fetch();
  }, []);

  if (loading.connectToCanva) {
    return <CircularProgress />;
  }

  return null;
};
